import TomSelect from "tom-select";
import formAlerts from "../../modules/default/form-alerts";
import initFilter from "../../modules/default/filter";
import initForms from "../../modules/default/forms";
import initModals from "../../modules/default/modal";
import initSwiper, {
    initProductDetailSwiper,
} from "../../modules/default/swiper";
import initTabs from "../../modules/default/tabs";
import initToggle from "../../modules/default/toggle";
import datlinq from "../../modules/default/datlinq";
import addWindowScrollPositionToDocument from "../../modules/default/viewport";
import initVideoSrc from "../../modules/default/video-src";
import initNewsletterPopup from "../../modules/default/newsletter-popup";
import requestSubmitPolyFill from "../../polyfill/form-request-submit";
import initCookieConsent from "../../modules/default/cookie-consent";
import initAddressesToggle from "../../modules/oetker/addresses-toggle";
import initSentry from "../../modules/default/sentry";
import initSampleRequestFormSelector from "../../modules/default/sample-request-form-selector";
import initFronzenSnacksOrderForm from "../../modules/default/frozen-snacks-order-form";

requestSubmitPolyFill(HTMLFormElement.prototype);

formAlerts();
initFilter();
initForms();
initModals();
initSwiper();
initProductDetailSwiper();
initTabs();
initToggle();
datlinq();
initNewsletterPopup();
addWindowScrollPositionToDocument();
initVideoSrc();
initAddressesToggle();
initSampleRequestFormSelector();

const tomSelectElements = document.querySelectorAll(
    "select[multiple][custom-select]"
);
const tomSelectConfig = {
    plugins: ["remove_button", "checkbox_options"],
    sortField: {
        field: "text",
        direction: "asc",
    },
    maxItems: 3,
};

tomSelectElements.forEach((tomSelectElement) => {
    new TomSelect(tomSelectElement, tomSelectConfig);
});

window.onload = () => {
    initCookieConsent();
    initSentry();
};

document.addEventListener('DOMContentLoaded', () => {
    initFronzenSnacksOrderForm();
});
